<ui-title [title]="'Welcome to QAR/SOD'"></ui-title>

<p>
	To start please click on the menu bar on top or go to the <a [routerLink]="'p/help'">help section</a>
</p>

<div *ngIf="canSeeDashboard">
	<ui-loading [loadingText]="'Please wait while the data is getting load...'" *ngIf="loading"></ui-loading>
	<div class="row">
		<div class="col-lg-3 m-1" *ngFor="let kv of dashboard.data|kv">
			<div class="card {{kv.key=='UnsolvedAnomalyCountInActiveSystem'?'card-unimportant':''}}">
				<div class="card-header">{{ dashboard.descriptions[kv.key] ? dashboard.descriptions[kv.key] : kv.key }}
				</div>

				<div class="card-body {{kv.value>0?'red-important':'green-important'}}" *ngIf="kv.key!='ExceptionLogs' && kv.key!='ReportSchedule' && kv.key!='RejectedQuarterlyStatus'"><b>{{ kv.value }}</b>

				</div>
				<div class="card-body" *ngIf="kv.key=='ReportSchedule'">

					<div *ngFor="let kv3 of kv.value">
						{{ kv3.ReportType }}

						<b class="green" *ngIf="kv3.Date!='0001-01-01T00:00:00'">{{ kv3.Date|date }}</b>
						<b class="red" *ngIf="kv3.Date=='0001-01-01T00:00:00'">Not Set</b>

					</div>
				</div>
				<div class="card-body" *ngIf="kv.key=='ExceptionLogs'">
					<div *ngFor="let kv2 of kv.value|kv">
						{{ dashboard.serverLogsDescriptions[kv2.key] ? dashboard.serverLogsDescriptions[kv2.key] : kv2.key }}
						<b class="green" *ngIf="kv2.value==-1">OK</b>
						<b class="red" *ngIf="kv2.value==-2">Exception</b>
						<b class="red" *ngIf="kv2.value!=-1 && kv2.value!=-2">{{ kv2.value }}Kb</b>

					</div>
				</div>
				<div class="card-body" *ngIf="kv.key=='RejectedQuarterlyStatus'">
					<div *ngFor="let kv3 of kv.value">
						{{ dashboard.rejectedQuarterlyStatusDes[kv3.Status] ? dashboard.rejectedQuarterlyStatusDes[kv3.Status] : kv3.Status }}
						<b [ngClass]="kv3.Status === 'done_verified'? 'green': 'red' ">{{ kv3.Count }}</b>

					</div>
				</div>
			</div>
		</div>
	</div>


	<div class="row">
		<div class="col-lg-4" style="margin:30px 5px;">
			<button mat-button class="btn-primary" (click)="checkLoaderLog()">
				Check all the loaders log
			</button>
		</div>
		<ui-loading [loadingText]="'Please wait while the data is getting load...'" *ngIf="loadingLog"></ui-loading>
		<div class="col-lg-12" style="padding-top:30px;" *ngIf="loaderLogData">
			<div class="card">
				<ui-table
					[headers]="[
				{label:'System Name'},
				{label:'Loader Name'},
				{label:'Date Last Batch'},
				{label:'Status'},
				{label:'Anomalies'},
				{label:'Count Rows'},
				{label:'Average Row Count (one year)'},
				{label:'Previous Batch Count Rows'}
				]"
					[options]="{noToolbar:true,noEmptyText:true}">
					<tr *ngFor="let log of loaderLogData" style=" {{log.batchStatus==='error'?'background:#ae1414;color:white':''}}">
						<td>{{ log.systemName }}</td>
						<td>{{ log.loaderName }}</td>
						<td>{{ log.dateLastBatch | date }}</td>
						<td class="text-capitalize">{{ log.batchStatus }}</td>
						<td>{{ log.anomalies }}</td>
						<td>{{ log.countRows }}</td>
						<td>{{ log.averageRowCount }}</td>
						<td>{{ log.previousRowCount }}</td>
					</tr>
				</ui-table>
			</div>
		</div>
	</div>
</div>


